import type { ReactElement } from 'react';
import BevSafeText from '../../../bev-safe-text';
import Button from '../../../button';
import CheckmarkOutline from '../../../icon/checkmark_outline';

import type { Product } from './types';

export type BookingSuccessProps = {
	product?: Product;
	itineraryDisclaimer: string;
	itineraryPath?: string;
	addMoreHref?: string;
	t: (text: string, params?: (string | number)[]) => string;
	onAddMore: () => void;
	onViewItinerary: () => void;
};

export default function BookingSuccess({
	product,
	itineraryDisclaimer,
	itineraryPath,
	addMoreHref,
	t,
	onAddMore,
	onViewItinerary,
}: BookingSuccessProps): ReactElement {
	const addMoreLabel =
		{
			spa: t('Add more Spa Experiences'),
			dining: t('Add more Dining Experiences'),
		}[product?.category?.name?.toLowerCase() || ''] || t('Add more Experiences');

	return (
		<div className="flex flex-col items-center gap-300 text-center" data-testid="booking-success">
			<h3 className="text-subtitle2 text-text-heading">{t('Request Sent')}</h3>

			<CheckmarkOutline aria-hidden width={32} height={32} />

			<p className="text-body2 text-text-primary">
				<BevSafeText>{itineraryDisclaimer}</BevSafeText>
			</p>

			<Button
				intent="filled"
				onClick={
					addMoreHref
						? () => {
								window.location.href = addMoreHref;
							}
						: onAddMore
				}
			>
				{addMoreLabel}
			</Button>

			{itineraryPath && (
				<button
					type="button"
					onClick={onViewItinerary}
					className="text-button2 text-text-primary underline"
				>
					{t('View in Itinerary')}
				</button>
			)}
		</div>
	);
}
